import React from 'react';
import { ReactComponent as Warning } from '@/assets/images/svg/warning.svg';

export const TransferContent: React.FC = (): JSX.Element => (
  <React.Fragment>
    <div className="exclude-container">
      <Warning color="#E64F49" />
      <div className="header-title-text modal__title">
        <h5 className="modal__confirmation-title">
          Você tem certeza que deseja alterar o status dessa solicitação?
        </h5>
      </div>
      <div className="modal__confirmation-text">
        Ao alterar o status, não será possível reverter.
      </div>
    </div>
  </React.Fragment>
);
